export const SET_LOADING = 'APP/SET_LOADING';
